<template>
    <input :type="props.type" v-model="input">
</template>

<style></style>

<script setup>
    import { defineModel, defineProps } from 'vue';
    const input = defineModel('input');
    const props = defineProps({
        type: {
            type: String,
            required: true,
        },
    });
</script>
